import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { LanguageModal } from 'components/common/LanguageModal';
import { SquareIconButton } from 'components/common/SquareIconButton';
import { ReactComponent as MarShopping } from 'assets/images/icons/v1/mar-shopping-red.svg';
import { ReactComponent as FlagPortugal } from 'assets/images/icons/v2/FlagPortugal.svg';
import { ReactComponent as FlagSpain } from 'assets/images/icons/v2/FlagSpain.svg';
import { ReactComponent as FlagUK } from 'assets/images/icons/v2/FlagUK.svg';
import { useSelector } from 'react-redux';
import { GetTopBarLabel } from 'helpers/utils';
import { useNavigate, useLocation } from 'react-router';
import { colors } from 'config/colors';
import { useRouterTransition } from 'hooks/useRouterTransition'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

export const TopNavMobile = ({ counter }) => {
  const locale = useSelector(state => state.language);
  const layout = useSelector(state => state.layout);
  const { pathname } = useLocation();

  let navigate = useNavigate();
  let { handleTransition } = useRouterTransition(navigate);

  const [isOpen, setIsOpen] = useState(false);

  const getLangIcon = () => {
    if (locale === 'pt-PT') return <FlagPortugal width="50" height="50" />
    if (locale === 'es-ES') return <FlagSpain width="50" height="50" />
    if (locale === 'en-US') return <FlagUK width="50" height="50" />
  };

  const goHome = () => {
    navTo('/');
  };

  const navTo = (url, state) => {
    handleTransition (url, state)
  };

  return (
    <Row
      className="px-4 py-3 h-100 "
      style={{
        zIndex:15,
        backgroundColor: !layout.homepage ? colors.white : colors[process.env.REACT_APP_ZONE].medium,
        color: !layout.homepage ? colors.white : colors['beije'].medium
      }}
    >
      <Col xs="2" onClick={goHome} className="d-flex align-items-center justify-content-center">
        <SquareIconButton icon={<MarShopping height="50" />} size="50px" />
      </Col>
      {counter &&
      <Col xs="2" className="d-flex align-items-center justify-content-center">
        <CountdownCircleTimer
          isPlaying
          key={counter}
          duration={counter}
          colors={colors[process.env.REACT_APP_ZONE].medium}
          onComplete={goHome}
          size="30"
          strokeWidth="2"
        >
          {({ remainingTime }) => <span style={{ color: colors.black, fontSize: '2.5vw' }}>{(remainingTime)}s</span> }
        </CountdownCircleTimer>
      </Col>
      }
      <Col xs={ counter ? '6' : '8' } className="d-flex align-items-center justify-content-center">
        <span
          style={{
            fontSize: '3vw',
            fontWeight: '600',
            color: !layout.homepage ? colors['grey'].medium : colors.white,
            marginLeft: counter ? '-10.0vw' : '0'
          }}
        >
          <FormattedMessage id={GetTopBarLabel(pathname)} defaultMessage="os" />
        </span>
      </Col>
      <Col xs="2" className="d-flex align-items-center justify-content-center">
        <SquareIconButton size="50px" icon={getLangIcon()} onClick={() => setIsOpen(true)} />
      </Col>
      <LanguageModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </Row>
  );
};